module.exports = __webpack_public_path__ + "img/bus.be5030ca.webp";